// =====================================
//
//   editAddress Modal
//   Author: Gray
//   createtime: 2016 / 03 / 08
//   updatetime: 2016 / 03 / 08
//
// =====================================

window.InifECApp.directive('editAddress', ['$rootScope', '$stateParams', '$timeout', '$ngModal', 'UserService',
    function($rootScope, $stateParams, $timeout, $ngModal, UserService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            // --------------------------------
            // [private] 打開 Modal
            // --------------------------------
            var openModal = function() {

                $ngModal.openModal('edit-address-modal');
            }

            // --------------------------------
            // [private] 關閉 Modal
            // --------------------------------
            var closeModal = function() {

                $ngModal.closeModal('edit-address-modal');
            }

            // --------------------------------
            // 新增／修改
            // --------------------------------
            var submit = function() {

                if($scope.isLoading) {
                    return;
                }

                checkFormValue();

                if($scope.isParamsEmpty || $scope.isParamsError) {
                    return;
                }

                var _submit = $scope.isEdit ? UserService.updateFavoriteAddress : UserService.addFavoriteAddress,
                    name = $scope.form.name,
                    phone = $scope.form.phone,
                    mobilephone = $scope.form.mobilephone,
                    postal = $scope.form.postal,
                    address = $scope.form.address,
                    remark = $scope.form.remark,
                    phoneExtension = $scope.form.phoneExtension,
                    index = $scope.index;

                $scope.isLoading = true;

                _submit(name, phone, mobilephone, postal, address, remark, phoneExtension, index).then(function(result) {

                    if(result) {
                        $scope.isLoading = false;
                        ($scope.callback) && $scope.callback(result);
                        closeModal();
                    }

                }, function(error) {

                    $scope.isError = true;
                    $scope.isLoading = false;

                    if(!error || !error.message) {
                        $scope.errorMsg = '系統忙碌中，請稍後再試';
                        return;
                    }

                    $scope.errorMsg = error.message;
                })
            }

            // --------------------------------
            // [private] 檢查表單內容
            // --------------------------------
            var checkFormValue = function() {

                $scope.isError = false;
                $scope.isParamsEmpty = false;
                $scope.isParamsError = false;

                $scope.isNameEmpty = false;
                $scope.isAddressEmpty = false;
                $scope.isPhoneEmpty = false;
                $scope.isPostalEmpty = false;
                $scope.isPostalError = false;
                $scope.isPhoneError = false;
                $scope.isMobilePhoneError = false;

                if(!$scope.form.name || $scope.form.name == '') {
                    $scope.isNameEmpty = true;
                    $scope.isParamsEmpty = true;
                }

                if(!$scope.form.address || $scope.form.address == '' || !$scope.form.newAddress) {
                    $scope.isAddressEmpty = true;
                    $scope.isParamsEmpty = true;
                }

                if(!$scope.form.postal || $scope.form.postal == '') {
                    $scope.isPostalEmpty = true;
                    $scope.isParamsEmpty = true;
                }

                if($scope.form.postal && isNaN($scope.form.postal)) {
                    $scope.isPostalError = true;
                    $scope.isParamsError = true;
                }

                if((!$scope.form.phone || $scope.form.phone == '') && (!$scope.form.mobilephone || $scope.form.mobilephone == '')) {
                    $scope.isPhoneEmpty = true;
                    $scope.isParamsEmpty = true;
                }

                if($scope.form.phone && !isPhone($scope.form.phone)) {
                    $scope.isPhoneError = true;
                    $scope.isParamsError = true;
                }

                if($scope.form.mobilephone && !isPhone($scope.form.mobilephone)) {
                    $scope.isMobilePhoneError = true;
                    $scope.isParamsError = true;
                }
            }

            // --------------------------------
            // [private] 重設所有表單內容
            // --------------------------------
            var resetFormValue = function() {
                
                $scope.form.name = '';
                $scope.form.postal = '';
                $scope.form.address = '';
                $scope.form.mobilephone = '';
                $scope.form.phone = '';
                $scope.form.remark = '';
                $scope.form.phoneExtension = '';
            }

            // --------------------------------
            // [private] 重設所有判斷
            // --------------------------------
            var resetState = function() {

                $scope.isError = false;
                $scope.isParamsEmpty = false;
                $scope.isParamsError = false;

                $scope.isNameEmpty = false;
                $scope.isAddressEmpty = false;
                $scope.isPhoneEmpty = false;
                $scope.isPostalEmpty = false;
                $scope.isPostalError = false;
                $scope.isPhoneError = false;
                $scope.isMobilePhoneError = false;
            }

            // --------------------------------
            // [private] 設定表單內容
            // --------------------------------
            var setFormValue = function(address) {

                $scope.form.name = address.name ? address.name : '';
                $scope.form.postal = address.postal ? address.postal : '';
                $scope.form.twZipCode = address.twZipCode ? address.twZipCode : '';
                $scope.form.address = address.address ? address.address : '';
                $scope.form.mobilephone = address.mobilephone ? address.mobilephone : '';
                $scope.form.phone = address.phone ? address.phone : '';
                $scope.form.remark = address.remark ? address.remark : '';
                $scope.form.phoneExtension = address.phoneExtension ? address.phoneExtension : '';
            }

            var init = function() {

            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_ADD_ADDRESS_MODAL", function(event, data) {

                if(data) {
                    $scope.isLoading = false;
                    $scope.isEdit = false;
                    $scope.callback = data.callback;

                    resetFormValue();
                    resetState();
                    openModal();    
                }
            });

            $scope.$on("OPEN_EDIT_ADDRESS_MODAL", function(event, data) {

                if(data) {
                    $scope.isLoading = false;
                    $scope.isEdit = true;
                    $scope.callback = data.callback;
                    $scope.index = data.index;

                    setFormValue(data.address);
                    openModal();    
                }
            });


                
            /*==========================
                Members
            ==========================*/
            $scope.form = {
                name: '',
                postal: '',
                address: '',
                mobilephone: '',
                phone: '',
                remark: '',
                phoneExtension: '',
                city: '',
                dist: '',
                newAddress: '',
            };

            $scope.index = undefined;

            $scope.isEdit = false;
            $scope.isLoading = false;
            $scope.isError = false;
            $scope.isNameEmpty = false;
            $scope.isAddressEmpty = false;
            $scope.isPhoneEmpty = false;
            $scope.isParamsEmpty = false;
            $scope.isParamsError = false;
            $scope.isPostalEmpty = false;
            $scope.isPostalError = false;
            $scope.isPhoneError = false;
            $scope.isMobilePhoneError = false;

            $scope.errorMsg;

            /*==========================
                Methods
            ==========================*/
            $scope.callback = undefined;
            // 新增／修改
            $scope.submit = submit;

            /*==========================
                init
            ==========================*/

            init();

        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'partials/modal/edit_address.html';
        _dir.controller = controller;

        return _dir;
}]);